import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Serializer } from "@shared/mirage/helpers/Serializer";
import { WeeklyListsFilter } from "./WeeklyListsFilter";
import WeeklyListsSimpleSearch from "./WeeklyListsSimpleSearch";
import { atom, useRecoilState } from "recoil";
import { EntityTableStateStorage } from "@mirage/components/entityTable/EntityTableStateStorage";
import SearchActions from "../SearchActions";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";

const defaultFilter = {
    dateCreatedFrom: null,
    dateCreatedTo: null,
} as WeeklyListsFilter;

const weeklyListsSearchState = atom({
    key: "weeklyListsSearchState",
    default: defaultFilter,
});

export const WeeklyListsSearch = () => {
    const navigate = useNavigate();
    const pp = new PublicPortalRoutingService();
    const [filter, setFilter] = useRecoilState<WeeklyListsFilter>(weeklyListsSearchState);

    function setFilterModifier(modifier: Partial<WeeklyListsFilter>) {
        setFilter((prev) => {
            return { ...prev, ...modifier };
        });
    }

    const onClear = () => {
        setFilter(() => {
            return {
                ...defaultFilter,
            };
        });
    };

    const onSearchClicked = () => {
        const filterParams = Serializer.toQueryParamsNotEmptyOnly(filter);
        EntityTableStateStorage.clear("weeklyLists");
        navigate(`${pp.SearchRoute("WeeklyLists", filterParams)}`);
    };

    function formActions() {
        return <SearchActions onSubmitHandler={onSearchClicked} onCancelHandler={onClear} />;
    }

    function simpleSearchForm() {
        return <WeeklyListsSimpleSearch state={filter} setter={setFilterModifier} />;
    }

    return (
        <Box>
            {simpleSearchForm()}
            {formActions()}
        </Box>
    );
};
